<template>
  <div class="dk--bot-msg-container" :class="{ 'dk--bot-is-typing': message.isTyping, 'dk--bot-msg-only': message.type === 'html' }">
    <span class="dk--bot-avatar" :style="{ backgroundImage: 'url(' + store.botImageUrl + ')' }"></span>

    <div v-if="message.isTyping" class="dk--bot-msg dk--bot-is-typing">
      {{ store.botName }} kirjoittaa...
    </div>
    <div v-else
         :class="'dk--bot-msg dk--bot-msg-' + message.ID"
         v-html="message.config?.default?.trim().length === 0 ? message.label : (message.config?.default ?? message.label)"
    ></div>

    <div v-if="!message.isTyping" class="dk--answer" :class="{ 'dk--answered': message.answered }">
      <DkBotInput :message="message" v-if="this.typesForInput.text.includes(message.type)"></DkBotInput>
      <DkBotSelect :message="message" v-if="message.type === 'dropdown'"></DkBotSelect>
    </div>
  </div>
</template>

<script>
import DkBotInput from "@/components/DkBotInput.vue";
import DkBotSelect from "@/components/DkBotSelect.vue";
import { store } from '@/store.js';

export default {
  name: "DkBotMessage",
  components: {
    DkBotInput,
    DkBotSelect,
  },
  props: {
    message: Object,
  },
  data() {
    return {
      store,
      typesForInput: {
        text: ['text', 'email', 'phone', 'number']
      },
    }
  },
  mounted() {
    if (this.message.scriptToRun) {
      Function(this.message.scriptToRun[1])();
    }
  }
}
</script>

<style lang="scss">

.dk--bot-msg-container {
  position: relative;
  overflow: hidden;
  min-height: var(--dk--bot-avatar-width--lg);

  &:not(:first-child) {
    margin-top: var(--dk--bot-msg-space);
  }

  /*&.dk--bot-msg-only + li:not(.dk--bot-msg-only) {
    margin-top: var(--dk--bot-msg-space-after-msg-only);
  }

  &.dk--bot-msg-only + li:not(.dk--bot-msg-only) .dk--bot-avatar {
    display: none;
  }*/

  .dk--bot-avatar {
    background-size: 110%;
    width: var(--dk--bot-avatar-width);
    height: var(--dk--bot-avatar-width);
    border-radius: var(--dk--bot-avatar-width);
    position: absolute;
    left: 0;
    top: 0;

    @media (min-width: 768px) {
      width: var(--dk--bot-avatar-width--lg);
      height: var(--dk--bot-avatar-width--lg);
      border-radius: var(--dk--bot-avatar-width--lg);
    }
  }

  .dk--bot-msg {
    margin-top: 1px;
    margin-left: calc(var(--dk--bot-avatar-width) + var(--dk--bot-msg-avatar-gap));
    padding: var(--dk--bot-msg-padding);
    width: calc(100% - (var(--dk--bot-avatar-width) + var(--dk--bot-msg-avatar-gap)));
    min-height: var(--dk--bot-avatar-width);
    /*line-height: var(--dk--bot-avatar-width);*/
    background-color: var(--dk--bot-msg-bg-color);
    color: var(--dk--bot-msg-color) !important;
    border-radius: var(--dk--bot-msg-border-radius);
    border-top-left-radius: 0;
    display: inline-block;
    position: relative;
    box-sizing: border-box;

    @media (min-width: 768px) {
      margin-left: calc(var(--dk--bot-avatar-width--lg) + var(--dk--bot-msg-avatar-gap--lg));
      padding: var(--dk--bot-msg-padding--lg);
      width: auto;
      min-height: var(--dk--bot-avatar-width--lg);
    }

    /**
     * is-typing
     */
    &.dk--bot-is-typing {
      background-color: transparent;
      /*line-height: var(--dk--bot-avatar-width);*/
      /*padding-top: 0;
      padding-bottom: 0;*/
      font-style: italic;
    }

    /**
     * html content "fixes"
     */
    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }

  .dk--answer {
    box-sizing: border-box;
    font-size: var(--dk--bot-msg-font-size);
    display: flex;
    flex-flow: wrap;
    margin-top: var(--dk--bot-msg-space);
    margin-left: calc(var(--dk--bot-avatar-width) + var(--dk--bot-answer-avatar-gap));
    gap: 8px 4px;
    justify-content: flex-end;
    position: relative;

    @media (min-width: 768px) {
      margin-left: calc(var(--dk--bot-avatar-width--lg) + var(--dk--bot-answer-avatar-gap--lg));
    }
  }
}

</style>